module.exports = __webpack_public_path__ + "img/earth-pos-mark.8dfc37f7.png";